module.exports = __webpack_public_path__ + "static/media/1.89f9789a.png";